import Action from '../../classes/Action';
import {timelineElementMap} from '../../classes/timeline';
import {ITimelineElement, ITimelineElementParent} from '../../interfaces/Timeline';
import store, {StoreActions} from '../../state/store';
import {Timeline} from "../../classes/timeline/Timeline";

export default class DeleteTimelineElementAction extends Action
{
	constructor(elements: ITimelineElement | ITimelineElement[])
	{
		elements = Array.isArray(elements) ? elements : [elements];
		const pluralSuffix = elements.length > 1 ? 's' : '';

		const parents: ITimelineElementParent[] = [];
		const childIndices: number[] = [];

		for(const element of elements)
		{
			parents.push(element.getParent() as ITimelineElementParent);
			childIndices.push(element.getParent()!.getChildren().indexOf(element));
		}
	
		super(
			[elements],
			[elements, parents, childIndices],
			'Deleted ' + elements[0].getType() + pluralSuffix + (elements.length > 1 ? '' : ': ' + elements[0].name),
			[elements]
		);
	}

	do(elements : ITimelineElement[]) : void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId) 
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();

		for(const element of elements)
		{
			const parent = element.getParent() as ITimelineElementParent;
			const children = parent.getChildren();
			parent.setChildren(children.filter((child) => child.id !== element.id));
			element.onDelete();
		}

		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());
	}

	undo(elements : ITimelineElement[], parents: ITimelineElementParent[], childIndices: number[]) : void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId) 
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();

		elements.forEach((element, i) =>
		{
			const parent = parents[i];
			const children = parent.getChildren();
			children.splice(childIndices[i], 0, element);
			element.onAdded();
		});

		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());
	}

	verify(elements: ITimelineElement[])
	{
		return elements.length > 0;
	}
}
